import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class AnswerBox extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.num = null;
    this.background = null;
    this.lblLetter = null;
    this.beenClicked = false;

    this.background = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._NumberBox, this);

    this.workingWidth = this.background.width;
    this.workingHeight = this.background.height;

    this.lblLetter = ABCyaPhaser.Text.addText(0,0, 72, 0x006699, FontKeys._bpreplaybold, '2', this, true).setOrigin(0.5);

    this.alpha = 0;

    ABCyaPhaser.Container.setContainerInteractive(this);
  }

  showCorrect (waitTime) {
    if (this.beenClicked) return;// It's already gone

    this.scene.tweens.killTweensOf(this);

    ABCyaPhaser.Tweens.addTween(this, 540, { scale: 1.4, delay: waitTime }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this, 120, { scaleX: 1, scaleY: 1.1 },Phaser.Math.Easing.Quadratic.Out);
    });
  }

  goOut (waitTime) {
    if (this.beenClicked) return;// It's already gone

    this.scene.tweens.killTweensOf(this);

    ABCyaPhaser.Tweens.addTween(this, 440, { alpha: 0.4, scale: 1.2, delay: waitTime }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this, 220, { alpha: 0.2, scale: 0 },Phaser.Math.Easing.Quadratic.In);
    });
  }

  initWithValue (value) {
    this.beenClicked = false;
    this.num = value;
    this.lblLetter.text = value.toString();
    this.background.alpha = 1.0;
  }

  comeIn (waitTime) {
    this.alpha = 0;
    this.scale = 1.4;
    this.scene.tweens.killTweensOf(this);

    ABCyaPhaser.Tweens.addTween(this, 240, { scale: 1.6, alpha: 0.4, delay: waitTime }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this, 420, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  }

  clickIncorrect () {
    this.beenClicked = true;
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 420, { scale: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }
}